var _excluded = ["leftBtnText", "onLeftBtnClick", "showLogo", "onClose", "children", "classes", "contentClassName", "className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import Icon from "@xo-union/tk-component-icons";
import BrandLogo from "@xo-union/component-brand-logo";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import { ModalContainer, ModalPortal } from "@xo-union/ui-accessibility";
import styles from "../../css/fullscreen-modal.css";
var FullscreenModal = function FullscreenModal(_ref) {
  var leftBtnText = _ref.leftBtnText,
    onLeftBtnClick = _ref.onLeftBtnClick,
    showLogo = _ref.showLogo,
    onClose = _ref.onClose,
    children = _ref.children,
    classesProp = _ref.classes,
    contentClassName = _ref.contentClassName,
    className = _ref.className,
    restOfProps = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement("aside", _extends({
    className: "".concat(className, " ").concat(classes.container)
  }, restOfProps), /*#__PURE__*/React.createElement(ModalContainer, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classes['header-section']
  }, leftBtnText && onLeftBtnClick && /*#__PURE__*/React.createElement("button", {
    name: "left-btn",
    className: classes['left-btn'],
    onClick: onLeftBtnClick,
    type: "button"
  }, leftBtnText)), showLogo && /*#__PURE__*/React.createElement("div", {
    className: classes['header-section-center']
  }, /*#__PURE__*/React.createElement(BrandLogo, {
    name: "theknot",
    color: "primary",
    className: classes['tk-logo']
  })), /*#__PURE__*/React.createElement("div", {
    className: classes['header-section-right']
  }, /*#__PURE__*/React.createElement("button", {
    name: "close-btn",
    className: classes['close-btn'],
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "md"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentClassName, " ").concat(classes.content)
  }, children))));
};
FullscreenModal.defaultProps = {
  className: '',
  contentClassName: '',
  leftBtnText: '',
  onLeftBtnClick: null,
  showLogo: true
};
process.env.NODE_ENV !== "production" ? FullscreenModal.propTypes = {
  /**
   * Callback to invoke when the close button is clicked
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Contents of the modal
   */
  children: PropTypes.node.isRequired,
  /**
   * Text for optional left button
   */
  leftBtnText: PropTypes.string,
  /**
   * Callback to invoke when left button is clicked
   */
  onLeftBtnClick: PropTypes.func,
  /**
   * Show logo on header
   */
  showLogo: PropTypes.bool,
  /**
   * Additional styles to apply to the outer wrapper
   */
  className: PropTypes.string,
  /**
   * Additional styles to apply to the inner content wrapper
   * */
  contentClassName: PropTypes.string,
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'header', 'header-section', 'left-btn', 'header-section-center', 'tk-logo', 'header-section-right', 'close-btn', 'content'])
} : void 0;
export default FullscreenModal;